import api from "../index"

const signersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSignersList: build.query({
      query: (params) => ({
        url: `/signers`,
        method: "GET",
        params,
      }),
    }),
    createSigners: build.mutation({
      query: (body) => ({
        url: `/signers`,
        method: "POST",
        body,
      }),
    }),
    deleteSigners: build.mutation({
      query: ({ id }) => ({
        url: `/signers/${id}`,
        method: "DELETE",
      }),
    }),
    updateSigners: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/signers/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    getDocSigners: build.query({
      query: () => ({
        url: `/signers/doc-signers`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetSignersListQuery,
  useCreateSignersMutation,
  useDeleteSignersMutation,
  useUpdateSignersMutation,
  useGetDocSignersQuery,
} = signersApi
